import { axiosRef } from '.';

export const trackShipment = (id: any) =>
  axiosRef.get(`/track?shipment_id=${id}`);

export const addTrackShipment = (payload: any) =>
  axiosRef.post(`/track`, payload);

export const editTrackShipment = (payload: any) =>
  axiosRef.put(`/track`, payload);

export const resetPassword = (username: any) =>
  axiosRef.post(`/users/${username}/password_reset_link`);

export const resetLinkPassword = (payload: any) =>
  axiosRef.post(`/user/password_reset`, payload);
